import useWindowSize from './useWindowSize';

function useIsMobile():boolean {
    const windowSize = useWindowSize();
    return windowSize.width <= 1024;
}

export default useIsMobile
